"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContentRowsRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const ContentRowsRoot = exports.ContentRowsRoot = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, gridRowStyle } = param;
    return {
        display: 'grid',
        columnGap: theme.spacing(2),
        rowGap: theme.spacing(6),
        margin: 0,
        width: '100%',
        height: '100%',
        gridTemplateColumns: '1fr 1fr',
        [theme.breakpoints.up('sm')]: {
            columnGap: theme.spacing(3),
            gridTemplateColumns: gridRowStyle
        }
    };
});
